import React, { useState, useRef, useCallback } from 'react';
import './IntegrationPrompt.less';
import { IntegrationType } from '@decisions/server/DecisionsFramework/Design/IntegrationType';
import { DesignerPromptLayer } from './DesignerPromptLayer';
import { Button } from 'components/buttons';

export interface IIntegrationPromptProps {
  onClose?: () => void;
  integrationType: IntegrationType;
  showViewButtonWithoutConfigureIntegration: boolean;
  onViewClick: () => void;
  getEditingContextId?: () => Promise<string>;
}

export function IntegrationPrompt({
  onClose,
  integrationType,
  showViewButtonWithoutConfigureIntegration,
  getEditingContextId,
  onViewClick,
}: IIntegrationPromptProps) {
  const [isLayerVisible, setIsLayerVisible] = useState<boolean>(false);
  const ref: React.MutableRefObject<HTMLElement | any> = useRef(null);

  const ChoiceType = useCallback(() => (
    <Button
      className="dp-integration-prompt__link"
      variant="link"
      dropdown
      onClick={() => setIsLayerVisible(true)}
      textTransform="capitalize"
      dropDownOpened={isLayerVisible}
    >
      {getIntegrationTypeString(integrationType)}
    </Button>
  ), [integrationType, isLayerVisible]);

  return (
    <div ref={ref} className="dp-integration-prompt">
      {integrationType === IntegrationType.None && !showViewButtonWithoutConfigureIntegration && <ChoiceType />}

      {integrationType !== IntegrationType.None && !showViewButtonWithoutConfigureIntegration && (
        <>
          <div className="dp-integration-prompt__label">Publish As:</div>
          <ChoiceType />
          {integrationType !== IntegrationType.InternalService && (
            <Button className="dp-input-data-prompt__button" variant="outline" onClick={onViewClick}>
              View
            </Button>
          )}
        </>
      )}

      {showViewButtonWithoutConfigureIntegration && (
        <Button className="dp-input-data-prompt__button" variant="outline" onClick={onViewClick}>
          View
        </Button>
      )}

      {isLayerVisible && (
        <DesignerPromptLayer
          category='Service Settings'
          getEditingContextId={getEditingContextId}
          onClose={() => {
            setIsLayerVisible(false);
            onClose && onClose();
          }}
          sourceRef={ref}
        />
      )}
    </div>
  );
}

function getIntegrationTypeString(integrationType: IntegrationType) {
  switch (integrationType) {
    case IntegrationType.ExternalService: {
      return 'API Service';
    }
    case IntegrationType.InternalService: {
      return 'Internal Only';
    }
    case IntegrationType.UiOrForm: {
      return 'User Interface';
    }
    case IntegrationType.WebHook: {
      return 'Webhook';
    }
    case IntegrationType.None: {
      return 'Configure Integration';
    }
  }
}
